
























import {Component, Prop, Vue} from 'vue-property-decorator'
import MenusStore from "@/store/modules/MenusStore";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";


@Component({
    components: {
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class DeleteMenuDialog extends Vue {
    @Prop() private menuId!: number;

    get title(): string {
        const menu = MenusStore.menuById[this.menuId] || {};
        const menuName = menu.name || "メニュー";
        return "【 " + menuName + " 】を削除してもよろしいですか？"
    }
}
